import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'SingleStack',
})(({ breakpoints, aspectRatio }) => ({
  stackText: {
    display: 'flex',
    flexDirection: 'column',
  },
  singleImage: {
    aspectRatio: aspectRatio['16/9'],
    [breakpoints.up('md')]: {
      aspectRatio: aspectRatio['21/9'],
    },
  },
  ctaContainer: {
    display: 'flex',
  },
}));

export default useStyles;
